import './layout.css';
import { Container } from './Container';

export function Section({
  id,
  as: Element = 'section',
  tone = 'default',
  className = '',
  children,
}) {
  return (
    <Element id={id} className={`section section--${tone} ${className}`.trim()}>
      <Container>{children}</Container>
    </Element>
  );
}
